import { createRootRoute } from '@tanstack/react-router';

const rootRoute = createRootRoute();

export default rootRoute;
